import { IAffairPub } from "@api/affair.int";
import { IGeoGroupPub } from "@api/geo-group.int";
import { Box, Button, Divider, Heading, Icon, Stack } from "@chakra-ui/react";
import { AFFAIR_KINDS, AFFAIR_KINDS_ARR, Bogyo } from "components/appComponents";
import { GEO_GROPUS, isLocationAffair, useVVStore } from "components/store";
import { formatDateTime } from "components/utils";
import { VizvCard, VizvCardHeaderPopup, VizvMainCol } from "components/vizvComponents";
import { HUNGARY_CENTER } from "features/map/MyMap";
import { NavMainLink } from "features/NavMain";
import { useEffect, useState } from "react";
import { FaSearchLocation } from "react-icons/fa";
import { MdArrowForward } from "react-icons/md";
import { Outlet, useNavigate, useParams } from "react-router";



export function VVGroup() {
	const store = useVVStore();
	const nav = useNavigate();

	const routeParams = useParams();
	const [groupItems, setGroupItems] = useState<IGeoGroupPub[]>([]);
	const [affairItems, setAffairItems] = useState<IAffairPub[]>([]);
	const [parentName, setParentName] = useState('');
	const [parent, setParent] = useState<IGeoGroupPub>();
	useEffect(() => {
		let _parent = store.groupList.find(f => f.groupKey === routeParams.region);
		if (!_parent) {
			setGroupItems(store.groupList.filter(group => group.parentKey === 'hu'));
			setParent(undefined);
			setParentName('Magyarország');
			store.setMapMoveIntoView({ zoom: 8.7, center: HUNGARY_CENTER })
		} else {
			setGroupItems(store.groupList.filter(group => group.parentKey === routeParams.region));
			setParent(_parent);
			setParentName((_parent?.title || '???') + (_parent.geoGroupLevel === 'Region' && _parent.title !== 'Budapest' ? ' Megye' : ''));
			const gix = GEO_GROPUS.findIndex(g => g.geoGroup === _parent!.geoGroupLevel);
			store.setMapMoveIntoView({ zoom: GEO_GROPUS[gix].zoomIn, center: _parent.longLat });
			const allAffairs = store.affairList.filter(aff => aff.parentKey === _parent!.groupKey);
			allAffairs.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
			setAffairItems(allAffairs.splice(0, 5));
			store.setSuggestionList([]);
		}
	}, [store.groupList, routeParams.region, store.affairList]);

	const isMobile = store.isMobile();
	const isDetailed = !!routeParams.affairKey || !!routeParams.userKey;
	const navRoot = '/group' + (parent ? '/region/' + parent?.groupKey : '');
	const navBack = parent? ('/group' + (parent.parentKey ? '/region/' + parent.parentKey : '')) : '/map';
	const backName = store.groupList.find(g => g.groupKey === parent?.parentKey)?.title || 'Magyarország';

	const affairClick = (affair: IAffairPub) => {
		//nav(navRoot + '/affair/' + affair.affairKey);
		const loc = store.itemsList.find(item => isLocationAffair(item) && item.dbAffair === affair);
		store.setSuggestionList(loc ? [loc] : []);

	}

	const affairHover = (affair: IAffairPub) => {
		/*const loc = store.itemsList.find(item => isLocationAffair(item) && item.dbAffair === affair);
		store.setSuggestionList(loc ? [loc] : []);*/
	}

	useEffect(() => {
		return () => {
			store.setSuggestionList([]);
		}
	}, []);

	return <>
		<VizvMainCol isTool={{ width: 400, isDetailed }} mapNavRoot={navRoot} >
			<VizvCard isTool
				{...navBack && { onBack: () => nav(navBack) }}
				isClosable
				mr={5} mt={5}
				maxHeight="calc(100vh - 4em)"
			>
				{/*(parent || isMobile) && <>
					<Box display='flex' mt={4} mb={1} w='100%' justifyContent='space-between'>
						{parent && <Box position='relative' left='-.5em' width='fit-content' bg='#292f3a'>
							<Button onClick={() => nav(navBack)} color='#fffa' bg='#292f3a' size='sm' borderRadius={0} fontWeight='400' leftIcon={<MdArrowBack />}>{backName}</Button>
						</Box>}
						{isMobile && <Box ml='auto' position='relative' right='-.6em' width='fit-content' bg='#292f3a'>
							<Button onClick={() => store.setLayoutPush('menu_and_tools')} color='#fff' bg='#292f3a' size='sm' borderRadius={0} fontWeight='400' rightIcon={<MdArrowForward />} >Térkép</Button>
						</Box>}
					</Box>
				</>*/}

				<VizvCardHeaderPopup fontSize='x-large' fontWeight='400' variant="blue" mb={2} {...parent && { mt: 0 }}>
					{parentName}
				</VizvCardHeaderPopup>
				<Box flex='1' overflowY='auto' overflowX='hidden'>

					{parent && <>

						<Stack fontSize='sm' lineHeight='normal' px={3} py={1} mb={1}>

							{AFFAIR_KINDS_ARR.map(KIND => ({ KIND, sum: parent.sumInfo[`affairCount_${KIND.key}`] as number }))
								.filter(item => item.sum > 0)
								.map((item) => <Box key={item.KIND.key}

								>{item.sum}&nbsp;
									<Box as='span' color={item.KIND.color} fontWeight='500' >{item.KIND.name}</Box></Box>)}
							{parent.sumInfo.guardCount > 0 && <>
								<Divider />
								<Box>
									{parent.sumInfo.guardCount} <Box as='span' color='primary.300' fontWeight='500'>VízVédő</Box>
								</Box></>}


						</Stack>
					</>}


					{affairItems.length > 0 && <>
						<Heading left='1em' fontSize='md' m={2} fontWeight='500'>A legújabbak:</Heading>
						{affairItems.map((affair) => <NavMainLink
							onClick={() => affairClick(affair)}
							onMouseEnter={() => affairHover(affair)}
							key={affair.affairKey}
							fontSize='small' lineHeight='normal'
							px={3} py={1} mb={1}
						>
							<Bogyo kind={affair.affairKind} />
							<Box>
								<Box color='InactiveCaptionText'>{formatDateTime(affair.createdAt)}</Box>
								<Box>{AFFAIR_KINDS[affair.affairKind].name}</Box>
								<Box>{affair.title}</Box>
							</Box>
						</NavMainLink>)}
					</>}



					{groupItems.map((group) =>
						<NavMainLink to={`/group/region/${group.groupKey}`} key={group.groupKey}

							//px={3} py={1} 
							mb={3} gap={2}
						>
							<Icon as={FaSearchLocation} fontSize='xx-large' color='#6abadb' />
							<Box					>
								<Box fontWeight='500' textDecor='xunderline'>{group.title}</Box>

								<Box fontSize='small' lineHeight='normal' color='#fffa'>{group.sumInfo.affairCount} Eset</Box>
								{group.sumInfo.guardCount > 0 && <Box fontSize='small' lineHeight='normal' color='#fffa'>{group.sumInfo.guardCount} Vízőr</Box>}
							</Box>
						</NavMainLink>)}
				</Box>

				{(isMobile) && <>
					<Box display='flex' mt={0} mb={1} px={1} w='100%' justifyContent='space-between'>
						<Button onClick={() => store.setLayoutPush('menu_and_tools')} 
							variant='link'
							ml='auto'
							color='#fff' 
							size='sm' borderRadius={0} fontWeight='400' 
							rightIcon={<MdArrowForward />} >Nagyobb térkép</Button>
					</Box>
				</>}

			</VizvCard>

		</VizvMainCol>
		<Outlet />
		{/*routeParams.affairKey && <AffairLayout isDetail={true} />*/}
	</>



}

export function groupSumPropblem(g: IGeoGroupPub) {

}